import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import IbnSina from '../assets/img/sponsor1.png';
import Popular from '../assets/img/sponsor2.png';
import United from '../assets/img/sponsor3.png';
import Lalpathlabs from '../assets/img/sponsor4.jpg';
import Thyrocare from '../assets/img/sponsor5.png';
import IBF from '../assets/img/sponsor7.jpg';
import Sponsor12 from '../assets/img/sponsor12.jpg';
import { AuthContext } from '../context/AuthContext';

const FALLBACK_LABS = [
  { name: 'Popular', image: Popular },
  { name: 'Ibn Sina', image: IbnSina },
  { name: 'United', image: United },
  { name: 'Dr. Lal PathLabs', image: Lalpathlabs, className: 'lalpaths' },
  { name: 'Thyrocare', image: Thyrocare, className: 'thyrocare' },
  { name: 'IBF', image: IBF },
  { name: 'Sponsor12', image: Sponsor12 },
];

const Sponsor = () => {
  const { postActivity } = useContext(AuthContext);
  const [partnerLogos, setPartnerLogos] = useState([]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/press/banner-get/?banner_type=lab-partner&is_active=true&ordering=sorting&limit=50`
      )
      .then((resp) => {
        if (resp.data?.results && resp.data.results.length > 0) {
          setPartnerLogos(resp.data.results);
        }
      })
      .catch(() => {});
  }, []);

  const baseLabs = partnerLogos && partnerLogos.length > 0 ? partnerLogos : FALLBACK_LABS;
  // Repeat array so marquee has seamless infinite loop
  const marqueeItems = [...baseLabs, ...baseLabs, ...baseLabs];

  return (
    <section className='sponsor'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h5 className='section-heading'>Our Lab Partners</h5>
          </div>
          <div className='col-12'>
            <marquee className='images'>
              {marqueeItems.map((item, i) => (
                <img
                  key={i}
                  onClick={() =>
                    postActivity('banner', 'Lab Partner', window.location.href)
                  }
                  src={item.image}
                  alt={item.name || ''}
                  className={item.className || ''}
                />
              ))}
            </marquee>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsor;
